<!-- View Acknowledgement -->
<div id="viewackdtls" aria-modal="true">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header p-2 border-bottom">
        <div class="pl-3 mb-0 heading-small text-white">View Details</div>
        <button type="button" class="close pr-4 text-white" data-dismiss="modal" (click)="close();">×</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="row pb-1">
                <div *ngFor="let res of notificationsList">
                    <a class="pt-2" href="javascript:void()" (click)="navigateToRequests(res)">
                        Request {{res.Request_Id}}
                        <span *ngIf="res.CaseProcessAction == 3"> received a response. </span>
                        <span *ngIf="res.CaseProcessAction == 4"> has a new correspondence email communication. </span>
                    </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
